import { render, staticRenderFns } from "./EmailCampaigns.vue?vue&type=template&id=208eca26&scoped=true"
import script from "./EmailCampaigns.vue?vue&type=script&lang=js"
export * from "./EmailCampaigns.vue?vue&type=script&lang=js"
import style0 from "./EmailCampaigns.vue?vue&type=style&index=0&id=208eca26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208eca26",
  null
  
)

export default component.exports